import React from "react";
import { Link, NavLink } from 'react-router-dom';

class Header extends React.Component {

    /*constructor(props) {
        super(props);
    }

    componentDidMount() {
    }*/

    render() {
        return (
            <header className="header">
                <img className="header__logo" src="../images/logo-fmm.svg" />

                <div>
                    <p className="tinyupper">Ordnen nach</p>
                    <div className="header__sort">
                        <NavLink className="header__label" activeClassName="header__label--active" exact to={`/`}>Zufall</NavLink>
                        <NavLink className="header__label" activeClassName="header__label--active" to={`/time/`}>Zeit</NavLink>
                        <NavLink className="header__label" activeClassName="header__label--active" to={`/color/`}>Farbe</NavLink>
                        <NavLink className="header__label" activeClassName="header__label--active" to={`/artist-list/`}>Künstler*in</NavLink>
                    </div>
                </div>
            </header>
        )
    }
}

export default Header;